export default {
  series: 1,
  data: 'Category;Series 1\nA;10\nB;5',
  seriesMapping: [
    {
      x: 0,
      name: 0,
      y: 1,
    },
  ],
  assignDataFields: [
    {
      name: 'A',
      y: 'B',
    },
  ],
};
